function SectionHeadingWrapper({ children }) {
    return <div className="md:mb-16 mb-10">{children}</div>
}

export default SectionHeadingWrapper
